import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import {Link} from "react-router-dom";
import Title from "../Title";
import ProjectSingle from "../ProjectSingle";
import Button from "../Button";
import {black, regular, text} from "../../styles/globalStyleVars";
const MyComponent = ({data}) => {

    return (
        <StyledComponent className={'feature-projects pt-200 pb-200'}>
            <Container>
                <Row>
                    <Col sm={12}>
                        <Title margin={'0 0 60px 0'} marginMobile={'0 0 40px 0'}
                               text={'Featured Projects'} fontWeight={`${regular}`}/>
                    </Col>
                </Row>
                <Row>
                    {
                        data &&  data?.length>0 &&
                        data?.map((element)=>{
                            return(
                                <Col sm={6}>
                                    <ProjectSingle img={element?.thumb ? element?.thumb :'/images/static/default-thumb.jpg'} title={element?.type?.name}
                                                   desc={element?.post_title}
                                                   link={`project/${element?.post_name}`}/>
                                </Col>
                            )
                        })
                    }

                    {/*<Col sm={6}>*/}
                    {/*    <ProjectSingle img={'/images/dynamic/home/p-2.jpg'} title={'Project Category'}*/}
                    {/*                   desc={'Project Title'}*/}
                    {/*                   link={`project/1`}/>*/}
                    {/*</Col>*/}
                    {/*<Col sm={6}>*/}
                    {/*    <ProjectSingle img={'/images/dynamic/home/p-3.jpg'} title={'Project Category'}*/}
                    {/*                   desc={'Project Title'}*/}
                    {/*                   link={`project/1`}/>*/}
                    {/*</Col>*/}
                    {/*<Col sm={6}>*/}
                    {/*    <ProjectSingle img={'/images/dynamic/home/p-4.jpg'} title={'Project Category'}*/}
                    {/*                   desc={'Project Title'}*/}
                    {/*                   link={`project/1`}/>*/}
                    {/*</Col>*/}

                </Row>
                <Row>
                    <Col sm={12}>
                        <Button src={'/projects'} width={'fit-content'} text={'View All'} color={`${black}`} border={`1px solid ${text}`} icon/>
                    </Col>
                </Row>
            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  padding-top: 200px !important;
  position: relative;
  background-color: #F6F6F6;
  @media (max-width: 767px){
    padding-top: 120px !important;
  }
  @media (max-width: 650px) {
    .col-sm-6 {
      min-width: 100%;
    }
  }
`;

export default MyComponent;

